module.exports = __webpack_public_path__ + "images/category_lp/camera/new/assessment_achievements/2_a0f743c3ace8016eeb7d6bbcdee53c1d.png";